/* v8 ignore start */
const SUB_LOCATIONS_MAP = Object.freeze({
  gh: [
    "1st Floor Bathroom",
    "1st Floor Landing 410-412",
    "1st Floor Landing 413-418",
    "1st Floor Landing 419-421",
    "1st Floor Landing Meds Room",
    "1st Floor Stairs",
    "2nd Floor Landing",
    "2nd Floor Shower Room",
    "2nd Floor Stairs",
    "Back Stairs",
    "Basement Corridor",
    "Basement Office",
    "Basement Stairs",
    "Car Park",
    "Conservatory",
    "Corridor 402-406",
    "Court Yard",
    "Dining Room",
    "Entrance Porch",
    "Garden Room",
    "Garden Toilet",
    "Ground Floor Lift Corridor",
    "Ground Floor Shower Room",
    "Ground Floor Toilet",
    "Hallway",
    "Main House Lift",
    "Main Lounge",
    "Main Patio",
    "New Block 430-432",
    "New Block 433-437",
    "New Block Lift",
    "New Lounge",
    "Quiet Lounge",
    "Quiet Lounge Patio",
    "Rear Garden",
    "Rear Garden Smoking Shelter",
    "Staff Room",
    "The Chapel",
  ],
  mf: [
    "Activity Room",
    "Bottom Outside Lift",
    "Bottom Steps",
    "Bottom Terrace",
    "Car Park",
    "Communal Bathroom",
    "Corridor 1-4",
    "Corridor Sun Lounge",
    "Dining Room",
    "Hallway",
    "Laundry",
    "Middle Corridor 5-9",
    "Middle Entrance 10-11",
    "Middle Landing",
    "Middle Steps",
    "Middle Terrace",
    "Residents Kitchen",
    "Smoking Shelter",
    "Sun Terrace",
    "Sunroom",
    "Top Corridor 12-13",
    "Top Corridor 14",
    "Top Garden",
    "Top Landing",
    "Top Outside Lift",
  ],
});

const getSubLocations = (locationId) => {
  return SUB_LOCATIONS_MAP[locationId] || [];
};

export default getSubLocations;
/* v8 ignore stop */
